import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ModalProps = {
	isOpen: boolean;
}
 
interface UiStateProps {
    partnerList: ModalProps,
	filterDrawer: ModalProps,
	individualProfileDrawer: ModalProps
}


const initialState: UiStateProps = {
	partnerList: {
		isOpen: true
	},
	filterDrawer: {
		isOpen: false
	},
	individualProfileDrawer: {
		isOpen: false
	}
}

const uiSlice = createSlice({
	name: 'uiSlice',
	initialState,
	reducers: {
		setIsPartnerListDrawerOpen(state, { payload: { isOpen } }: PayloadAction<{ isOpen: ModalProps['isOpen'] }>) {
			state.partnerList.isOpen = isOpen
		},
		setIsFilterDrawerOpen(state, { payload: { isOpen } }: PayloadAction<{ isOpen: ModalProps['isOpen'] }>) {
			state.filterDrawer.isOpen = isOpen
		},
		setIsIndividualProfileDrawerOpen(state, { payload: { isOpen } }: PayloadAction<{ isOpen: ModalProps['isOpen'] }>) {
			state.individualProfileDrawer.isOpen = isOpen
		},
	}
})

export const uiSliceActions = uiSlice.actions
export default uiSlice.reducer
